import {createAction} from "redux-act";

export const getSquadsJson = createAction();

export interface ISquad {
	id: number;
	name: string;
	abbreviation: string;
	color: null | string;
	logo: null | string;
	location: string;
	shortName: string;
}

export const getSquadsJsonSuccess = createAction<ISquad[]>();
export const getSquadsJsonFailed = createAction();
